import { EventEmitter, Injectable } from '@angular/core';
import { StorageItem } from '@ieShared/interfaces/dynamic-form.interface';
import { StorageDirectory } from 'shared-general-libs/enum/storage';

@Injectable({
  providedIn: 'root',
})
export class FileViewerService {
  onProvideFile = new EventEmitter<{
    file: StorageItem;
    storageDir: StorageDirectory;
  } | null>();

  constructor() {}

  showFile(file: StorageItem, storageDir: StorageDirectory): void {
    this.onProvideFile.emit({
      file: file,
      storageDir: storageDir,
    });
  }

  hideFile(): void {
    this.onProvideFile.emit(null);
  }
}
